import { SignOutIcon as PhosphorSignOutIcon } from "@phosphor-icons/react/dist/ssr/SignOut";

import { createAppIcon } from "@/components/createAppIcon";

export const LogoutIcon = /* @__PURE__ */ createAppIcon(PhosphorSignOutIcon);
